// Small display formatters. Money display lives in the number-format context
// (`useNumberFormat().formatMoney`); date display uses `toLocaleDateString`
// at the call site — the former `fmtMoney`/`fmtDate` here were unused dupes.

export function fmtPct(n: number): string {
  return new Intl.NumberFormat(undefined, { style: "percent", maximumFractionDigits: 1 }).format(n);
}
